import React, { useState } from "react";
import {
  Box,
  IconButton,
  Collapse,
  Typography,
  Paper,
  makeStyles,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles((theme) => ({
  infoButton: {
    padding: 4,
    marginLeft: theme.spacing(1),
  },
  infoPaper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  triggerType: {
    fontWeight: "bold",
    marginBottom: theme.spacing(0.5),
  },
  description: {
    marginBottom: theme.spacing(2),
    "&:last-child": {
      marginBottom: 0,
    },
  },
}));

const TRIGGER_TYPE_INFO = [
  {
    type: "ClassCompletion",
    description: "Triggered when a user completes a class",
  },
  {
    type: "ClassMinutesSpent",
    description: "Triggered based on the total minutes spent in classes",
  },
  {
    type: "ClassTaken",
    description:
      "Triggered when a user takes a class (regardless of completion)",
  },
  {
    type: "PostComment",
    description: "Triggered when a user posts a comment",
  },
  {
    type: "PostUpload",
    description: "Triggered when a user uploads a post",
  },
  {
    type: "RequiredClassCompletion",
    description: "Triggered when a user completes specific required classes",
  },
  {
    type: "RequiredClassTaken",
    description: "Triggered when a user takes specific required classes",
  },
];

export const TriggerTypeInfo = () => {
  const classes = useStyles();
  const [showInfo, setShowInfo] = useState(false);

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle2" color="textSecondary">
          Trigger Type
        </Typography>
        <IconButton
          className={classes.infoButton}
          onClick={() => setShowInfo(!showInfo)}
          size="small"
          title={showInfo ? "Hide trigger type info" : "Show trigger type info"}
        >
          <InfoIcon fontSize="small" />
        </IconButton>
      </Box>
      <Collapse in={showInfo}>
        <Paper className={classes.infoPaper} variant="outlined">
          {TRIGGER_TYPE_INFO.map(({ type, description }) => (
            <Box key={type} className={classes.description}>
              <Typography className={classes.triggerType}>{type}</Typography>
              <Typography variant="body2" color="textSecondary">
                {description}
              </Typography>
            </Box>
          ))}
        </Paper>
      </Collapse>
    </>
  );
};
